import React from 'react';

import WindowSizeContextProvider from './useWindowSize';

export const wrapWithProviders = ({ element }) => <WindowSizeContextProvider>{element}</WindowSizeContextProvider>;

export default wrapWithProviders;
